import { ComponentF } from "../../../ui/ui";
import Colors from "../../Colors";
import { gameData } from "../../GameManager";
import { MAP_DEPTH } from "../../gameState";

export const DepthInfo: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C) => {
  C.display.drawText(
    C.bounds.x + C.bounds.w / 2 - 6,
    C.bounds.y,
    `%c{${Colors.GRAY_3}}Depth ${gameData.current.depth} / ${MAP_DEPTH}`
  );

  if (gameData.freeEntry) {
    C.display.drawText(
      C.bounds.x + 15,
      C.bounds.y + 2,
      `%c{${Colors.RED}}Free Entry, place a word in any open location`
    );
  }
};
